import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Locale } from '../i18n'
import { t } from '../i18n'

const RTL_LOCALES: Locale[] = []

function applyLocale(locale: Locale) {
  document.documentElement.lang = locale
  document.documentElement.dir = RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr'
}

interface LocaleState {
  locale: Locale
  isRTL: boolean
  setLocale: (l: Locale) => void
  t: (key: Parameters<typeof t>[1], fallback?: string) => string
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set, get) => ({
      locale: 'en',
      isRTL: false,
      setLocale: (locale) => {
        const isRTL = RTL_LOCALES.includes(locale)
        applyLocale(locale)
        set({ locale, isRTL })
      },
      t: (key, fallback) => t(get().locale, key, fallback),
    }),
    {
      name: 'ggram-locale',
      onRehydrateStorage: () => (state) => {
        if (state) applyLocale(state.locale)
      },
    },
  ),
)
